import React from "react";
import ShiftSummary from "../child/ShiftSummary";
import WorkOrderCounts from "../child/WorkOrderCounts";
import WorkOrderCompletionByMonth from "../child/WorkOrderCompletionByMonth";
import WorkOrderPriorityChart from "../child/WorkOrderPriorityChart";
import WorkOrderStatusChart from "../child/WorkOrderStatusChart";
import FailureCodeChart from "../child/FailureCodeChart";
import CauseCodeChart from "../child/CauseCodeChart";
import DepartmentOutstandingTable from "../child/DepartmentOutstandingTable";
import NotificationsPriorityChart from "../child/NotificationsPriorityChart";
import NotificationsOpenClosedChart from "../child/NotificationsOpenClosedChart";
import NotificationsOutstandingChart from "../child/NotificationsOutstandingChart";

const OverviewDashboardLayer = () => {
  return (
    <div className='row gy-4 p-24'>
      {/* ShiftSummary */}
      <ShiftSummary />
      
      {/* WorkOrderCounts */}
      <WorkOrderCounts />

      {/* WorkOrderCompletionByMonth */}
      <WorkOrderCompletionByMonth />


      {/* WorkOrderPriorityChart */}
      <WorkOrderPriorityChart />   

      {/* WorkOrderStatusChart */}
      <WorkOrderStatusChart />

      {/* DepartmentOutstandingTable */}
      <DepartmentOutstandingTable />
      
      {/* FailureCodeChart */}
      <FailureCodeChart />

      {/* CauseCodeChart */}
      <CauseCodeChart />

      {/* NotificationsPriorityChart */}
      <NotificationsPriorityChart />

      {/* NotificationsOpenClosedChart */}
      <NotificationsOpenClosedChart />

      {/* NotificationsOutstandingChart */}
      <NotificationsOutstandingChart />
    </div>
  );
};

export default OverviewDashboardLayer;
